import Alpine from 'alpinejs'
import { dispatch } from '../../node_modules/alpinejs/src/utils/dispatch'

/**
 * dispatches:
 * - currency-selected
 */
Alpine.store('currency', {
    
    currencies: [],
    selectedCurrency: {
        rate: 1,
        symbol: '€',
        name: 'Euro',
        code: 'EUR',
        codeLower: 'eur',
        isForeign: false,
        shortPrefix: '',
        shortSuffix: ',- €',
        longPrefix: '',
        longSuffix: ' €',
        commaSeparator: ',',
        thousandSeparator: '.',
    },
    
    setup(currencies, currencyCode) {
        this.currencies = currencies
        this.selectedCurrency = this.currencies.find(currency => currency.code === currencyCode)
        dispatch(window, 'currency-selected', { currency: this.selectedCurrency })
    },
    
    selectCurrency(currencyCode) {
        this.selectedCurrency = this.currencies.find(currency => currency.code === currencyCode)
        dispatch(window, 'currency-selected', { currency: this.selectedCurrency })
        
        if(this.selectedCurrency) {
            fetch('/misc_frontend/settings/currency/code/'+this.selectedCurrency.code, { 
                credentials: 'include', 
                method: 'POST' 
            })
        }
    },
    
    formatShort(amountMCU, currencyCode=null) {
        
        const currency = currencyCode ? this.currencies.find(currency => currency.code === currencyCode) : this.seletedCurrency
        
        return currency.shortPrefix
            + (((amountMCU * currency.rate)/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousandSeparator))
            + currency.shortSuffix
            + (currency.isForeign ? '*' : '')
    },
    
})